exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-box[data-v-aac3a14e]{position:center;width:50%;min-width:1000px;margin:50px auto;box-shadow:0 2px 8px 0 rgba(0,0,0,.1);min-height:500px}.content-body[data-v-aac3a14e]{padding:0 50px 0 40px}[data-v-aac3a14e] .el-timeline-item__timestamp.is-top{font-size:15px;padding-top:-3px}.highlight-submit-btn[data-v-aac3a14e]{background:#f16622;color:#fff;margin-top:20px;border:none}[data-v-aac3a14e] .el-upload--picture-card{width:80px;height:80px}[data-v-aac3a14e] .el-upload,[data-v-aac3a14e] .el-upload-list--picture-card .el-upload-list__item,[data-v-aac3a14e] .el-upload-list--picture-card .el-upload-list__item-thumbnail{width:80px;height:80px;line-height:80px}[data-v-aac3a14e] .avatar{width:80px;height:80px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aac3a14e","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/detail.vue
// module id = 932
// module chunks = 0